import { Box, ComponentVersionsInherit, ComponentVersions_3_0, Typography } from 'opensolar-ui'
import { useTranslate } from 'react-admin'

const Subtitle = () => {
  const translate = useTranslate()
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Box display="flex" flexDirection="column">
        <Typography variant="body2" color="textSecondary">
          {translate('Manage your customer contacts and assign pricing tiers for personalized pricing.')}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {translate('Note: Customers without assigned tiers see your default public prices.')}
        </Typography>
      </Box>
    </ComponentVersionsInherit>
  )
}

export default {
  list: { lazy: () => import('./CustomerList') },
  options: {
    list: {
      title: 'Customers',
      subtitle: <Subtitle />,
      breadCrumb: 'Customers',
    },
  },
}
